import { useEffect, useState } from "react";
import type { Variant } from "@/components/ui/VariantsManager";
import { apiFetch } from "@/lib/api";

export type Product = {
  id: string;
  name: string;
  name_en: string;
  description: string;
  description_en: string;
  slug: string;
  category: { name: string; name_en: string };
  brand: { name: string };
  status: { name: string };
  announcement: {
    id: string;
    message: string;
    message_en: string | null;
    text_color: string | null;
    background_color: string | null;
  } | null;
  variants: Variant[];
};

export function useProduct(id?: string) {
  const [product, setProduct] = useState<Product | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;

    setProduct(null);
    setError(null);

    apiFetch(`/admin/product/${id}`)
      .then(res => res.json())
      .then(setProduct)
      .catch(() => setError("Could not load product"));
  }, [id]);

  return { product, error, setProduct };
}
